/**
 * Greebles.
 * 
 */

/**
 * Greebles.
 * Mobile: On scroll, greebles lag and then catch up.
 * Desktop: On scroll, greebles lag and then catch up.
 */

const gsap = require("gsap/dist/gsap").gsap;
const ScrollTrigger = require("gsap/dist/ScrollTrigger").ScrollTrigger;

gsap.registerPlugin(ScrollTrigger);

let
	$window = $(window),
	$greebles = $('.g-container .grbl');

function initGreebles() {
	// console.log('GREEBLES: initGreebles()');
	// ANIM SETTLE IN ------------------------------------------------------------
	// Handles greebles' lagging inertia.

	let proxyL = { translateY: 0 },
	// maxOff = (Math.random() + 1) * 150,
	ySetterL = gsap.quickSetter(".grbl-l", "translateY", "px"), // fast
	clampL = gsap.utils.clamp(-300, 300); // don't let the offset go beyond 300px. 
	// clamp = gsap.utils.clamp(-maxOff, maxOff); // don't let the offset go beyond 300px. 

	ScrollTrigger.create({
		onUpdate: (self) => {
			let offset = clampL(self.getVelocity() / 25);
			// only do something if the offset is MORE severe.
			if (Math.abs(offset) > Math.abs(proxyL.translateY)) {
				proxyL.translateY = offset;
				gsap.to(proxyL, {
					translateY: 0, 
					duration: 3.6,
					ease: "power2", 
					overwrite: true, 
					onUpdate: () => ySetterL(proxyL.translateY)
				});
			}
		}
	});

	let proxyM = { translateY: 0 },
	// maxOff = (Math.random() + 1) * 150,
	ySetterM = gsap.quickSetter(".grbl-m", "translateY", "px"), // fast
	clampM = gsap.utils.clamp(-600, 600); // don't let the offset go beyond 600px. 
	// clamp = gsap.utils.clamp(-maxOff, maxOff); // don't let the offset go beyond 300px. 

	ScrollTrigger.create({
		onUpdate: (self) => {
			let offset = clampM(self.getVelocity() / 25);
			// only do something if the offset is MORE severe.
			if (Math.abs(offset) > Math.abs(proxyM.translateY)) {
				proxyM.translateY = offset;
				gsap.to(proxyM, {
					translateY: 0, 
					duration: 1.8,
					ease: "power3", 
					overwrite: true, 
					onUpdate: () => ySetterM(proxyM.translateY)
				});
			}
		}
	});

	let proxyS = { translateY: 0 },
	ySetterS = gsap.quickSetter(".grbl-s", "translateY", "px"), // fast
	clampS = gsap.utils.clamp(-450, 450); // don't let the offset go beyond 450px. 

	ScrollTrigger.create({
		onUpdate: (self) => {
			let offset = clampS(self.getVelocity() / 25);
			// only do something if the offset is MORE severe.
			if (Math.abs(offset) > Math.abs(proxyS.translateY)) {
				proxyS.translateY = offset;
				gsap.to(proxyS, {
					translateY: 0, 
					duration: 1.2,
					ease: "power3", 
					overwrite: true, 
					onUpdate: () => ySetterS(proxyS.translateY)
				});
			}
		}
	});
}

exports.init = function () {
	// console.log('GREEBLES: exports.init');
	// Run init methods...

	initGreebles();
};